import ReactDOM from 'react-dom/client'
import { App } from './App'
import { StrictMode } from 'react'

import * as Sentry from '@sentry/react'
import router from './router'

const appEnv = import.meta.env.VITE_APP_ENV
const isProduction = appEnv === 'production'

Sentry.init({
  dsn: 'https://dc7349da684598337b38fcb6441b3a8d@o404751.ingest.us.sentry.io/4509490889818112',
  environment: appEnv,
  sendDefaultPii: true,
  integrations: [
    Sentry.tanstackRouterBrowserTracingIntegration(router),
    ...(isProduction ? [Sentry.browserTracingIntegration(), Sentry.replayIntegration()] : []),
  ],
  ...(isProduction && {
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/app\.magicposts\.ai\/v1/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  }),
})

const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
